import "./InputRadio.css";

export const InputRadio = ({ caption, ...props }) => {
  return (
    <label className="input-radio">
      <input type="radio" name="direction" {...props} /> {caption}
    </label>
  );
};
